import PropTypes from 'prop-types'
import { Container, Row, Col } from '@mch-group/uikit-components'
import { cloudinary } from '@constants'
import styled from 'styled-components'
import { uploadTransformationUrl } from '@dmi-mch/utils'
import { detectDpr } from '@utils'
import ExpandText from '@reusable-modules/ExpandText'
import Directors from './Directors'
import WebsiteLink from './WebsiteLink'

const Content = ({ pageMetaInfo: data, readMoreLabel }) => (
  <Container as='section' className='gallery-detail-overview'>
    <Row gutter='g-5 g-md-6 g-xl-7 overview-text'>
      <Col xs={12} md={4}>
        {data && data.description && (
          <ExpandText className='mb-7' splitToP sliceAt={500} readMoreLabel={readMoreLabel}>
            {data.description}
          </ExpandText>
        )}
        <Directors directors={data.directors} />
        <WebsiteLink link={data.website} />
      </Col>
      <Col xs={12} md={{ span: 7, offset: 1 }}>
        <StyledImage>
          {data?.imageUrl && (
            <img
              className='border-radius-standard'
              alt={data.displayName}
              src={uploadTransformationUrl(
                data.imageUrl,
                `q_auto:best,${detectDpr()},ar_1.6,c_crop,c_fill,g_auto,w_848`,
                {
                  transformUrl: cloudinary.throughCloudfront
                }
              )}
            />
          )}
        </StyledImage>
      </Col>
    </Row>
  </Container>
)

const StyledImage = styled.div`
  aspect-ratio: 16 / 10;

  img {
    aspect-ratio: 16 / 10;
    display: block;
    max-width: 100%;
  }
`

Content.propTypes = {
  className: PropTypes.string,
  pageMetaInfo: PropTypes.object,
  readMoreLabel: PropTypes.string
}

export default Content
